import React, {useState, useEffect} from 'react'
import Popup from '../../Popup/Popup'
import Success from '../../Success/Success'
import Axios from '../../Axios/Axios'
import DemotionReason from './DemotionReason.js'
import AddNewReason from './AddNewReason.js'
import Spinner from '../../Spinner/Spinner'

function EditReasons(props) {
    const [loading, setLoading] = useState(true)
    const [upgradeReasons, setUpgradeReasons] = useState([])
    const [downgradeReasons, setDowngradeReasons] = useState([])
    const [upgradeActive, setUpgradeActive] = useState([])
    const [downgradeActive, setDowngradeActive] = useState([])
    const [success, setSuccess] = useState()

    useEffect(() => {
        Axios(props.endpoints.getReasons, { id: props.data.ID }, (data) => {
            const up = data.filter(r => r.IS_UPGRADE).map(r => ({ reason: r.REASON || '' }))
            const dn = data.filter(r => !r.IS_UPGRADE).map(r => ({ reason: r.REASON || '' }))
            setUpgradeReasons(up)
            setDowngradeReasons(dn)
            setUpgradeActive(up.map((_, i) => i))
            setDowngradeActive(dn.map((_, i) => i))
            setLoading(false)
        })
    }, [])

    const changeReason = (isUpgrade, field, value, index) => {
        if (isUpgrade) {
            setUpgradeReasons(prev => prev.map((r, i) => i === index ? { ...r, [field]: value } : r))
        } else {
            setDowngradeReasons(prev => prev.map((r, i) => i === index ? { ...r, [field]: value } : r))
        }
    }

    const addReason = (isUpgrade) => {
        if (isUpgrade) {
            const newIndex = upgradeReasons.length
            setUpgradeReasons(prev => [...prev, { reason: '' }])
            setUpgradeActive(prev => [...prev, newIndex])
        } else {
            const newIndex = downgradeReasons.length
            setDowngradeReasons(prev => [...prev, { reason: '' }])
            setDowngradeActive(prev => [...prev, newIndex])
        }
    }

    const deleteReason = (isUpgrade, index, alreadyRemoved) => {
        const setter = isUpgrade ? setUpgradeActive : setDowngradeActive
        setter(prev => {
            const filtered = prev.filter(i => i !== index)
            return alreadyRemoved ? [...filtered, index] : filtered
        })
    }

    const submit = () => {
        setSuccess(null)
        const reasons = [
            ...upgradeActive.map(i => ({ isUpgrade: true, reason: upgradeReasons[i].reason })),
            ...downgradeActive.map(i => ({ isUpgrade: false, reason: downgradeReasons[i].reason })),
        ]
        Axios(props.endpoints.setReasons, { id: props.data.ID, reasons }, () => {
            setSuccess(true)
        })
    }

    const renderSection = (title, isUpgrade, reasons, activeIndexes) => (
        <div style={{ flex: 1, minWidth: 280 }}>
            <div style={{ fontWeight: '700', marginBottom: 10, color: 'var(--text-secondary)', textTransform: 'uppercase', fontSize: 11, letterSpacing: '0.06em', borderBottom: '2px solid var(--border-strong)', paddingBottom: 4 }}>{title}</div>
            <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                {reasons.map((r, i) => activeIndexes.includes(i) && (
                    <DemotionReason
                        key={i}
                        data={r}
                        index={i}
                        changeReason={(field, val, idx) => changeReason(isUpgrade, field, val, idx)}
                        deleteReason={(idx, alreadyRemoved) => deleteReason(isUpgrade, idx, alreadyRemoved)}
                    />
                ))}
            </div>
            <AddNewReason addReason={() => addReason(isUpgrade)} />
        </div>
    )

    let body
    if (props.data) {
        body = (
            <div className={"pop-body"}>
                <div style={{ width: '100%' }}>
                    {loading ? <Spinner /> : (
                        <div style={{ display: 'flex', gap: 32, alignItems: 'flex-start' }}>
                            {renderSection('Upgrade Reasons', true, upgradeReasons, upgradeActive)}
                            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--border-strong)', flexShrink: 0 }} />
                            {renderSection('Downgrade Reasons', false, downgradeReasons, downgradeActive)}
                        </div>
                    )}
                </div>
                <div className={"pop-buttonRow"}>
                    <button type="button" id={"pop-cancel"} onClick={props.close}>CLOSE</button>
                    <button id={"pop-submit"} onClick={submit}>SUBMIT</button>
                </div>
            </div>
        )
    }

    if (success !== undefined) {
        return <Success {...props} success={success} successMessage={"Success! You have successfully updated the Reasons."} />
    }
    return <Popup {...props} body={body} title={"Edit Target Change Reasons"} />
}

export default EditReasons
